import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50ff78a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "register-login-modal" }
const _hoisted_4 = { class: "register-login-content" }
const _hoisted_5 = { class: "register-body" }
const _hoisted_6 = { class: "register-title m-0" }
const _hoisted_7 = { class: "register-body-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      class: "popup modal-dialog modal-dialog-centered modal-dialog-scrollable"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.title), 1)
                ], true),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}